<template>
  <v-row
    class="list--bordered"
  >
    <v-col
      cols="8"
      class="d-flex align-center"
    >
      <p class="body-2 ma-0">
        {{ specification.title }}
      </p>
    </v-col>
    <v-col
      cols="8"
    >
      <v-select
        v-if="specification.selectable && specification.selectable.length"
        v-model="specificationValue"
        outlined
        dense
        hide-details
        :items="specification.selectable"
        :multiple="specification.multiple || false"
      />
      <v-text-field
        v-else-if="specification.type === 'string'"
        v-model="specificationValue"
        outlined
        dense
        hide-details
      />
      <v-select
        v-else-if="specification.type === 'boolean'"
        v-model="specificationValue"
        outlined
        dense
        hide-details
        :items="[
          {value: true, text: 'Yes'},
          {value: false, text: 'No'}
        ]"
      />
    </v-col>
  </v-row>
</template>
<script>
  export default {
    name: 'SpecificationRow',
    props: {
      specification: {
        type: Object,
        required: true
      }
    },
    computed: {
      specificationValue: {
        get: function () {
          return this.specification.value
        },
        set: function (value) {
          this.$emit('update:specificationValue', value, this.specification.key)
        }
      }
    }
  }
</script>
